import { SceneState } from '../../components/SceneStatemachinePlugin';
import { ActionsPlayer } from 'game/components/ActionsPlayer.js';
import { magnifyingGlassControl } from 'game/components/MagGlassControl.js';
import { TRACK_COMPONENTS } from 'game/tracking/stats.js';
import { BACKGROUND_MUSIC } from '../../constants/Constants';

// =============================================================================================
// STATE : COIN FLIP
// =============================================================================================
export class StateScenarioEmotionCheck extends SceneState {
  constructor(scene, scenario) {
    super(scene);
    this._scenario = scenario;
  }

  startState() {
    const { names = {} } = this._scenario.tracking;
    this.game.stats.setScreenName(names.CHECK);
    this.game.stats.startComponent(TRACK_COMPONENTS.NOTICE);
    this.game.soundController.playMusic(BACKGROUND_MUSIC.INIFIC_SCREEN);
    const { configId } = this._scenario.emotion_check;
    const sceneCharacters = this._scenario.scene_objects
      .filter((o) => o.type === 'character')
      .map((c) => {
        return this.scene.getSceneObject(c.id, c.type);
      });
    this._config = this.game.cache.json.get(configId);
    const opts = { game: this.game, scene: this.scene, x: 0, y: 0, config: this._config };
    this._actionsPlayer = new ActionsPlayer(opts);
    this._actionsPlayer.addSceneCharacters(sceneCharacters);
    this._actionsPlayer.once('MAG_GLASS_SHOW', this.addMagnifyingGlass, this);
    this._actionsPlayer.once('MAG_GLASS_ACTIVATE', this.activateMagnifyingGlass, this);
    this._actionsPlayer.once('COMPLETE_ACTIONS', () => {
      this.scene.game.soundController.playSFX('sfx', 'character_whoosh');
      this.emit('state_complete');
    });
    this._actionsPlayer.start();
  }

  addMagnifyingGlass() {
    this.magnifyGlassControl = magnifyingGlassControl();
    const position = this._actionsPlayer.getActiveCharacterPosition();
    this.magnifyGlassControl.addMagnifyingGlass(this.scene, position, this._config.hotspots);
  }

  activateMagnifyingGlass() {
    this.magnifyGlassControl.activateMagnifyingGlass();
  }

  playHotSpotVO(data) {
    if (data?.vo) {
      if (data.character) {
        const character = this.scene.getSceneObject(data.character, 'character');
        character.setTalking(true);
        this.game.vo.play(data.vo, {
          onComplete: () => {
            character.setTalking(false);
            this.handleVOComplete(data);
          },
        });
      } else {
        this.game.vo.play(data.vo, {
          onComplete: () => {
            this.handleVOComplete(data);
          },
        });
      }
    }
  }

  handleVOComplete({ id }) {
    this.magnifyGlassControl.removeMagGlass(this.handleMagGlassRemoved, this);
  }

  handleMagGlassRemoved() {
    this.magnifyGlassControl.destroy();
    this._actionsPlayer.handleRunActionComplete('ev1');
  }

  onScenePaused() {}

  onSceneResumed() {}

  onSceneUpdate(time, delta) {
    this.magnifyGlassControl && this.magnifyGlassControl.handleDrag(this.game, this.scene, this);
  }

  endState() {
    this.game.stats.completeComponent(TRACK_COMPONENTS.NOTICE);
    if (this.magnifyGlassControl) {
      this.magnifyGlassControl.destroy();
      this.magnifyGlassControl = null;
    }
    if (this._actionsPlayer) {
      this._actionsPlayer.destroy();
      this._actionsPlayer = null;
    }
    if (this._container) {
      this._container.destroy();
      this._container = null;
    }
    if (this._timer) {
      this._timer.destroy();
      this._timer = null;
    }
  }
}
